<router-outlet>
  @if (isPWAAvailable && isPWABannerVisible) {
    <div class="pwa-install-banner" (click)="openPWAInstall()">
      <app-image img="assets/images/befree.png"></app-image>
      Установите приложение на экран <span>Домой</span>
      <ion-icon
        (click)="closePWABanner()"
        slot="icon-only"
        src="assets/images/icons-svg/close.svg"
      ></ion-icon>
    </div>
  }

  @if (isPWAInstallModalOpen) {
    <div
      class="pwa-install-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pwa-install-modal-title"
    >
      <div
        type="button"
        class="pwa-install-modal__backdrop"
        aria-label="Закрыть окно"
        (click)="closePWAInstallModal()"
      ></div>
      <div class="pwa-install-modal__panel">
        <h2 id="pwa-install-modal-title" class="pwa-install-modal__title">
          Установка приложения

          <ion-icon
            (click)="closePWAInstallModal()"
            slot="icon-only"
            src="assets/images/icons-svg/close.svg"
          ></ion-icon>
        </h2>

        <div class="pwa-install-modal__content">
          <p class="pwa-install-modal__text">
            Следуйте простым шагам ниже для установки PWA на ваше устройство
          </p>

          <div>
            <h3 class="pwa-install-modal__subtitle">iOS</h3>

            <ol class="pwa-install-modal__list">
              <li class="pwa-install-modal__list-item">
                Откройте в браузере сайт <span>https://social.befree.ru/</span>
              </li>

              <li class="pwa-install-modal__list-item">
                Нажмите на кнопку <span>Поделиться</span>

                <div class="pwa-install-modal__list-item-icon-container">
                  <div class="pwa-install-modal__list-item-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-share-icon lucide-share"
                    >
                      <path d="M12 2v13" />
                      <path d="m16 6-4-4-4 4" />
                      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                    </svg>
                  </div>

                  <b>или</b>

                  <div class="pwa-install-modal__list-item-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-ellipsis-icon lucide-ellipsis"
                    >
                      <circle cx="12" cy="12" r="1" />
                      <circle cx="19" cy="12" r="1" />
                      <circle cx="5" cy="12" r="1" />
                    </svg>
                  </div>
                </div>
              </li>

              <li class="pwa-install-modal__list-item">
                Прокрутите вниз и выберите <span>На экран Домой</span>
              </li>

              <li class="pwa-install-modal__list-item">
                Нажмите <span>Добавить</span> в правом верхнем углу
              </li>
            </ol>
          </div>

          <div>
            <h3 class="pwa-install-modal__subtitle">Android</h3>

            <ol class="pwa-install-modal__list">
              <li class="pwa-install-modal__list-item">
                Откройте в браузере сайт <span>https://social.befree.ru/</span>
              </li>

              <li class="pwa-install-modal__list-item">
                Нажмите на меню (три точки) в правом верхнем углу

                <div class="pwa-install-modal__list-item-icon-container">
                  <div class="pwa-install-modal__list-item-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-ellipsis-icon lucide-ellipsis"
                    >
                      <circle cx="12" cy="12" r="1" />
                      <circle cx="19" cy="12" r="1" />
                      <circle cx="5" cy="12" r="1" />
                    </svg>
                  </div>
                </div>
              </li>

              <li class="pwa-install-modal__list-item">
                Выберите <span>Добавить на главный экран</span> или
                <span>Установить приложение</span>
              </li>

              <li class="pwa-install-modal__list-item">Подтвердите установку</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  }
</router-outlet>
